import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { LOGOUT_SUCCESS, RESET_TO_INITIAL_STATE } from './auth';
import getTheme from '../../theme/theme';
var LOAD_THEME = 'likeablelocal/theme/LOAD_THEME';
var LOAD_THEME_SUCCESS = 'likeablelocal/theme/LOAD_THEME_SUCCESS';
var LOAD_THEME_FAIL = 'likeablelocal/LOAD_THEME/LOAD_THEME_FAIL';

var initialState = _objectSpread({}, getTheme());

export default function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_THEME_SUCCESS:
      return _objectSpread(_objectSpread({}, state), action.result.data);

    case RESET_TO_INITIAL_STATE:
    default:
      return state;
  }
}
export function loadTheme(orgId) {
  return {
    types: [LOAD_THEME, LOAD_THEME_SUCCESS, LOAD_THEME_FAIL],
    promise: function promise(client) {
      return client.get("/appTheme?orgId=".concat(orgId));
    }
  };
}